var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ok-btn.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-424ea784!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ok-btn.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/plugin/components/ok-btn.vue
// module id = 60
// module chunks = 0